import { Colors } from "@blueprintjs/core";
import { css } from "glamor";
import * as React from "react";
import { HashRouter, Redirect, Route, Switch } from "react-router-dom";
import Analytics from "react-router-ga";
import "./App.css";
import BackendTabs from "./Backend/BackendTabs";
import LiveOverviewContent from "./Backend/LiveOverviewContent";
import FightPageContainer from "./FightRoom/FightPageContainer";
import FightSelector from "./FightRoom/FightSelector";
import Header from "./Header";
import About from "./Public/About";
import CookieBanner from "./Public/CookieBanner";
import FightPlan from "./Public/FightPlan";
import Footer from "./Public/Footer";
import Privacy from "./Public/Privacy";
import RankingSelector from "./Public/RankingSelector";
import TeamRanking from "./Public/TeamRanking";

const styles = {
	App: (dark: boolean) =>
		css({
			backgroundColor: dark ? Colors.DARK_GRAY3 : Colors.LIGHT_GRAY5,
			height: "100%",
			minHeight: "100vh",
			color: dark ? Colors.LIGHT_GRAY5 + " !important" : Colors.DARK_GRAY3 + " !important",
		}),
	container: css({
		width: "100%",
		maxWidth: "1100px",
		margin: "auto",
		height: "100%",
		minHeight: "100vh",
		position: "relative",
	}),
	contentWrap: css({ paddingBottom: "100px", marginBottom: "20px" }),
};

class App extends React.Component<{}, { dark: boolean }> {
	public state = {
		dark: window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches,
	};

	private toggleDark = () => {
		this.setState({ dark: !this.state.dark });
	};
	public render() {
		return (
			<div className={this.state.dark ? "bp3-dark" : ""} {...styles.App(this.state.dark)}>
				<div {...styles.container}>
					<HashRouter>
						<Analytics id="UA-159852486-1" debug={true}>
							<div {...styles.contentWrap}>
								<Route
									path="/"
									render={() => <Header dark={this.state.dark} onChange={this.toggleDark} />}
								/>
								<Switch>
									<Redirect exact={true} from="/" to="/live" />

									<Route exact={true} path="/" />
									<Route
										exact={true}
										path="/fights"
										render={(props) => <FightSelector {...props} dark={this.state.dark} />}
									/>
									<Route
										exact={true}
										path="/fights/:fightId"
										render={(props) => <FightPageContainer {...props} dark={this.state.dark} />}
									/>
									<Route
										exact={true}
										path="/live"
										render={(props) => <LiveOverviewContent {...props} dark={this.state.dark} />}
									/>
									<Route
										exact={true}
										path="/fightplan"
										render={(props) => <FightPlan {...props} dark={this.state.dark} />}
									/>
									<Route
										exact={true}
										path="/ranking"
										render={(props) => <RankingSelector {...props} dark={this.state.dark} />}
									/>
									<Route
										exact={true}
										path="/ranking/:round"
										render={(props) => <TeamRanking {...props} dark={this.state.dark} />}
									/>
									<Route
										exact={true}
										path="/about"
										render={(props) => <About {...props} dark={this.state.dark} />}
									/>
									<Route
										exact={true}
										path="/backend"
										render={(props) => <BackendTabs {...props} dark={this.state.dark} />}
									/>
									<Route
										exact={true}
										path="/privacy"
										render={(props) => <Privacy {...props} dark={this.state.dark} />}
									/>
								</Switch>
							</div>
							<Footer dark={this.state.dark} />
							<CookieBanner dark={this.state.dark} />
						</Analytics>
					</HashRouter>
				</div>
			</div>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx